<script setup>
import { computed } from 'vue';
import { useAccount } from 'dashboard/composables/useAccount';
import { useI18n } from 'vue-i18n';

import SectionLayout from './SectionLayout.vue';

const WHATSAPP_RENEWAL_LINK = 'https://wa.me/5584936180448';

const { t } = useI18n();
const { currentAccount } = useAccount();

const daysLeft = computed(() => currentAccount.value.expiration_days_left);
const expirationDate = computed(() => currentAccount.value.expiration_date);
const isOnTrial = computed(
  () => currentAccount.value.display_status === 'trial'
);
const renewalLinkLabel = computed(() =>
  isOnTrial.value
    ? t('GENERAL_SETTINGS.ACCOUNT_EXPIRATION_BANNER.ACTIVATE_LINK')
    : t('GENERAL_SETTINGS.ACCOUNT_EXPIRATION_BANNER.RENEW_LINK')
);
</script>

<template>
  <SectionLayout
    :title="t('GENERAL_SETTINGS.FORM.ACCOUNT_ACTIVATION.TITLE')"
    description=""
    with-border
  >
    <template #description>
      <span v-if="expirationDate">
        {{ t('GENERAL_SETTINGS.ACCOUNT_EXPIRATION_BANNER.MESSAGE_PREFIX') }}
        {{ expirationDate }} -
        {{
          t('GENERAL_SETTINGS.ACCOUNT_EXPIRATION_BANNER.DAYS_COUNT', {
            count: daysLeft,
          })
        }}
        <span
          >(<a
            :href="WHATSAPP_RENEWAL_LINK"
            rel="noopener noreferrer nofollow"
            target="_blank"
            class="underline"
            >{{ renewalLinkLabel }}</a
          >)</span
        >
      </span>
      <span v-else>
        {{ t('GENERAL_SETTINGS.FORM.ACCOUNT_ACTIVATION.NO_EXPIRATION') }}
      </span>
    </template>
  </SectionLayout>
</template>
